import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Toaster from "@meforma/vue-toaster";

import "./assets/custom.scss";

createApp(App).use(router).use(store).use(Toaster).mount("#app");
